/**
 * Model to hold Team Type that will be saving to identity
 */
export class TeamType {
    public static HIGH_SCHOOL_ID: string = '057d8c00-4cab-4404-b484-f2113137f444';
    public static MIDDLE_SCHOOL_ID: string = '7c1a6d19-12df-4ee8-8cc8-9eb080ffaa06';
    public static ELEMENTARY_YOUTH_ID: string = 'efb684b5-c1cf-43bd-be48-c924928159b7';

    public id: string;
    public name: string;

    public clone(): TeamType {
        const clone: TeamType = new TeamType();
        clone.id = this.id;
        clone.name = this.name;
        return clone;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'teamType';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;
        return JSON.stringify(json);
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object): TeamType {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.name = attrs['name'];

        return this;
    }
}
